module.exports = __webpack_public_path__ + "img/Rhodium Stains.0fc13654.png";